import IntId from '@/domain/shared/intId/IntId';

export default class ClientId extends IntId {}
